import Border from '@ui/effects/Border'
import Gradient from '@ui/effects/Gradient'
import useRWD from '@ui/theme/useRWD'
import { gap } from '@ui/theme/values'
import { colors } from '@ui/colors'
import Status from '@ui/elements/Status'
import { StatusProps } from '@ui/elements/Status/types'
import Typography from '@ui/typography/Typography'
import { Image } from 'expo-image'
import { View } from 'react-native'
import cn from '@ui/utils/cn'
import { ImageAny } from '@ui/utils/image'

interface Props {
  title: string
  desc?: string
  body?: string
  badge?: StatusProps
  image?: ImageAny
}

export default function BannerLarge({
  title,
  desc,
  body,
  badge,
  image,
}: Props) {
  const { screen } = useRWD()

  const maxImageSize = screen.width - 2 * gap

  return (
    <View className="flex flex-col gap-0 overflow-hidden rounded-2xl">
      <Gradient
        colors={[colors.gray[75], colors.white, colors.white0]}
        start={[0, 0.5]}
        end={[1, 0.5]}
      />
      <Border className="rounded-2xl" />
      <View
        className={cn(
          'flex flex-col items-center justify-center gap-4 px-16 pt-8',
          body && 'pb-8'
        )}
      >
        {badge && (
          <View className="flex flex-row gap-4 pb-2">
            <Status {...badge} />
          </View>
        )}
        <Typography variant="LGB" className="text-center">
          {title}
        </Typography>
        {desc && (
          <Typography
            variant="MD"
            numberOfLines={3}
            className="text-center color-desc"
          >
            {desc}
          </Typography>
        )}
      </View>
      {image && (
        <View
          className="flex items-center justify-center"
          style={{
            width: '100%',
            height: (1 / 3) * maxImageSize,
          }}
        >
          <Image
            source={image}
            contentFit="contain"
            contentPosition="center"
            style={{
              width: '100%',
              height: '100%',
            }}
          />
        </View>
      )}
      {body && (
        <View className="border-t border-black/10 p-8">
          <Typography variant="XS" className="text-left opacity-50">
            {body}
          </Typography>
        </View>
      )}
    </View>
  )
}
